export default __webpack_public_path__ + "static/fern-118d14968b8fae04e122d9c97cd007b8.webp";